import React, { useState } from 'react';

interface InfoOffcanvasProps {
  title?: string;
  children: React.ReactNode;
  placement?: 'start' | 'end' | 'top' | 'bottom';
  buttonClass?: string;
  iconColor?: string;
  offcanvasClass?: string;
}

const InfoOffcanvas: React.FC<InfoOffcanvasProps> = ({
  title = "Información",
  children,
  placement = 'end',
  buttonClass = '',
  iconColor = '#28a745',
  offcanvasClass = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Trigger Button */}
      <button
        className={`info-offcanvas-btn ${buttonClass}`}
        onClick={handleToggle}
        type="button"
        aria-label="Mostrar información"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="9"
            stroke={iconColor}
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M10 7v6M10 5h.01"
            stroke={iconColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Bootstrap Offcanvas */}
      <div
        className={`offcanvas offcanvas-${placement} ${isOpen ? 'show' : ''} ${offcanvasClass}`}
        tabIndex={-1}
        style={{
          visibility: isOpen ? 'visible' : 'hidden',
          transform: isOpen ? 'none' :
            placement === 'end' ? 'translateX(100%)' :
              placement === 'start' ? 'translateX(-100%)' :
                placement === 'top' ? 'translateY(-100%)' :
                  'translateY(100%)'
        }}
        aria-labelledby="infoOffcanvasLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="infoOffcanvasLabel">
            {title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          {children}
        </div>
      </div>

      {/* Backdrop */}
      {isOpen && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={handleClose}
        ></div>
      )}
    </>
  );
};

export default InfoOffcanvas;